<div *ngIf="layoutService.displayProfileHeader"
     class="container"
     appStickyHeader="80">

  <!-- Title Image and Gradient Overlay -->
  <img src="assets/images/soccer-field-c.jpg" class="title-image" alt="title image">
  <div class="gradient"></div>

  <!-- Follow Button -->
  <div class="follow scale-on-hover"
       [class.light]="!isFollowed"
       (click)="toggleFollow()">
    {{ isFollowed ? 'GEFOLGT' : 'FOLGEN' }}
    <mat-icon>favorite</mat-icon>
  </div>

  <!-- Header Content -->
  <div class="header-content">
    <div class="logo" routerLink="/">
      <img [src]="league?.getLogoImageUrl('big')" alt="logo">
    </div>
    <div class="infos">
      <span class="title">{{league.name}}</span>
      <span *ngIf="!stateLink" class="subtitle">{{stateName}}</span>
      <a *ngIf="stateLink" class="subtitle" [href]="stateLink">{{stateName}}</a>
      <span class="followers">{{league.ui_names.followers}}</span>
      <span *ngIf="showId" (click)="copyEntityId()" class="entity-id">{{league.id}}</span>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tabs">
    <ng-container *ngFor="let tab of leagueService.tabs">
      <a *ngIf="tab.exists"
         mat-button
         class="tab rise-on-hover-light"
         [routerLink]="tab.link"
         draggable="false"
         routerLinkActive="active" [routerLinkActiveOptions]="{ exact: tab.exact }"
         [disableRipple]="true">
        <span>{{tab.name}}</span>
      </a>
    </ng-container>
  </div>
</div>
<router-outlet></router-outlet>
